package com.dotdrives.web.pages.forms

import com.dotdrives.controller.FormBuilderController
import com.dotdrives.controller.FormBuilderUiState
import com.dotdrives.controller.FormsBoardController
import com.dotdrives.controller.FormsBoardUiState
import com.dotdrives.controller.NewFormController
import com.dotdrives.controller.NewFormUiState
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.b
import react.dom.html.ReactHTML.div
import react.useEffect
import react.useState
import web.cssom.ClassName

external interface FormsPageProps : Props {
    var boardController: FormsBoardController
    var boardState: FormsBoardUiState
    var builderController: FormBuilderController
    var builderState: FormBuilderUiState
    var newFormController: NewFormController
    var newFormState: NewFormUiState
    var canWrite: Boolean
    var orgId: String
    var orgName: String?
    var onConnectStripe: () -> Unit
}

val FormsPage = FC<FormsPageProps> { props ->
    val location = com.dotdrives.web.useHashLocation()
    val selectedFormId = com.dotdrives.web.parseEntityRoute(location).entityFor(props.orgId)
    useEffect(selectedFormId) {
        if (selectedFormId != null) props.builderController.load(selectedFormId)
    }
    val (newFormOpen, setNewFormOpen) = useState(false)

    useEffect(props.boardController) {
        props.boardController.load()
    }

    useEffect(props.newFormState.savedForm?.id) {
        val saved = props.newFormState.savedForm
        if (saved != null) {
            setNewFormOpen(false)
            kotlinx.browser.window.location.hash = com.dotdrives.web.entityRouteHash(com.dotdrives.web.AppRoute.Forms, props.orgId, saved.id)
            props.boardController.load()
        }
    }

    FormsStyles()

    fun openForm(formId: String) {
        kotlinx.browser.window.location.hash = com.dotdrives.web.entityRouteHash(com.dotdrives.web.AppRoute.Forms, props.orgId, formId)
    }

    fun openNewFormDialog() {
        props.newFormController.start()
        setNewFormOpen(true)
    }

    if (selectedFormId != null) {
        FormBuilderPage {
            controller = props.builderController
            state = props.builderState
            canWrite = props.canWrite
            orgId = props.orgId
            orgName = props.orgName
            onBack = {
                kotlinx.browser.window.location.hash = com.dotdrives.web.workspaceHash("#/forms", props.orgId)
                props.boardController.load()
            }
        }
    } else {
        div {
            className = ClassName("forms-page")
            div {
                className = ClassName("forms-header")
                div {
                    className = ClassName("forms-title-block")
                    div { className = ClassName("forms-title"); +"Giving forms" }
                    div {
                        className = ClassName("forms-subtitle")
                        if (props.boardState.paymentReadiness != null) {
                            +props.boardState.paymentReadiness!!.summary
                        } else when (props.boardState.stripeConnected) {
                            true -> {
                                +"Online giving is "
                                b { +"enabled" }
                                +" · Stripe connected ✓"
                            }
                            false -> +"Online giving is off — connect Stripe to accept gifts"
                            null -> {}
                        }
                    }
                }
                if (props.canWrite) {
                    DotButton {
                        text = "+ New form"
                        className = "forms-topbar-button"
                        onClick = { openNewFormDialog() }
                    }
                }
            }
            FormsDashboard {
                state = props.boardState
                canWrite = props.canWrite
                orgId = props.orgId
                onOpenForm = { form -> openForm(form.id) }
                onNewForm = { openNewFormDialog() }
                onConnectStripe = props.onConnectStripe
                onRetry = props.boardController::retry
            }
        }
    }

    if (newFormOpen) {
        NewFormDialog {
            controller = props.newFormController
            state = props.newFormState
            targets = props.boardState.targets
            existingForms = props.boardState.forms
            onCancel = { setNewFormOpen(false) }
        }
    }
}
